// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/sessionLockTimeout.js#1 $
'use strict';

/**
* @ngdoc service
* @name tcApp.SessionLockTimeout
* @description
* Logic for locking session based on security group inactivity timeout
*
*/
angular.module('tcApp')
.factory('SessionLockTimeout', function($rootScope, $window, $location, $interval, $timeout, $log,
										GlobalService, OverlayService, SystemRouter, tcConstants) {
	var lockTimeoutId;
	var lockTimeoutTime = 0;
	var timeLockSession = '';
	var activityMonitor = null;
	var cancelMonitorUnbind;
	var externalUrlOrigin = null;
	var activityMessageTimeout = null;
	var logoutOnLockSession = false;
	var lockCountdown = tcConstants.SESSION_TIMEOUT.LOCK_COUNTDOWN; // amount of time (in seconds) the user is given to extend their session before it locks
	var warningOpen = false; // indicates whether the user is currently being warned about an imminent session expiration; if true, prevents resetTimer from firing
	var extendSession = false; // indicates whether the session should be extended (rather than locked) when the warning dialog closes
	var extendCount = 0; // the number of times the session has been extended
	var maxExtendCount = tcConstants.SESSION_TIMEOUT.MAX_EXTEND_COUNT; // maximum number of times the session can be extended before it will be forced to lock

	var lockSession = function lockSession() {
		if ($location.path() === '/DisabledSession') return;

		if (logoutOnLockSession) {
			GlobalService.logout(false);
		} else {
			OverlayService.close();
			GlobalService.lockSession();
		}
		try {
			$window.sessionStorage.removeItem('tc.activity');
		} catch (err) {
			$log.warn('Login token storage issue: ' + err);
		}
	};

	var warnSession = function warnSession() {
		warningOpen = true;

		var currentFocus = $window.document.activeElement;
		var cancelCallFunctionListener;
		var finalExtend = (extendCount === maxExtendCount - 1) ? 1 : 0;
		OverlayService.open({
			componentName: 'websys.WarnSession',
			params: '&LockCountdown=' + lockCountdown + '&FinalExtend=' + finalExtend,
			popup: true,
			focusHandler: function() {
				if ((currentFocus) && (angular.isFunction(currentFocus.focus))) currentFocus.focus();
			},
			onRemovingHandler: function() {
				warningOpen = false;

				if (angular.isFunction(cancelCallFunctionListener)) cancelCallFunctionListener();

				if (extendSession) {
					extendCount++;
					extendSession = false;
					resetTimer(false); // reset timer, but do not reset extendCount
				} else {
					$timeout(lockSession); // wrapped in timeout to avoid $rootScope:inprog error being thrown ad infinitum
				}
			},
			onOpenCompleteHandler: function() {
				// Add a temporary callFunction listener to detect if the user presses the Extend Session button on websys.WarnSession
				// Don't want just anyone to be able to call functions in this file, so only allow the specified function name,
				// and unsubscribe the listener once the overlay closes
				cancelCallFunctionListener = $rootScope.$on('Global:callFunction', function(event, componentHtmlName, functionName) {
					if ((componentHtmlName === 'SessionLockTimeout') && (functionName === 'ExtendSession')) {
						extendSession = true; // mark the session to be extended rather than locked when the overlay closes
					}
				});
			},
			clickOutsideToClose: false
		});
	};

	var resetTimer = function resetTimer(resetExtendCount/* = true*/) {
		if (warningOpen) return; // suppressed while warning dialog is open

		if (angular.isUndefined(resetExtendCount)) resetExtendCount = true; // IE doesn't support default values *aggressive eyeroll*

		$window.clearTimeout(lockTimeoutId);
		lockTimeoutTime = 0;
		// If we are in ME UI embedded in TC UI, pass session reset to TC UI
		if ((!GlobalService.isHealthShareViewer()) && ($window.top.tkSystemUI == false)) {
			$window.top.websys_LockSessionReset();
			return;
		}
		if (isLogonComponentOrLocked()) return;

		if (resetExtendCount) extendCount = 0;

		// When switching security groups, inactivity timeout can differ from initial value
		if (GlobalService.logonData.timeLockSession > 0) {
			// We can't use $timeout for session timeout because it will never run focusFirst
			if (extendCount >= maxExtendCount) {
				// Max number of extensions used - lock with no warning
				lockTimeoutId = $window.setTimeout(lockSession, timeLockSession * 60 * 1000, false); //eslint-disable-line
			} else {
				lockTimeoutId = $window.setTimeout(warnSession, (timeLockSession * 60 - lockCountdown) * 1000, false); //eslint-disable-line
			}
			// Preserve the time that the lock will trigger, so we can compare after returning from device sleep
			lockTimeoutTime = (Date.now() + (timeLockSession * 60 * 1000));
		}
		try {
			// On activity, set variable that can be used by region scripts to trigger additional code
			$window.sessionStorage.setItem('tc.activity', Date.now());
		} catch (err) {
			$log.warn('Activity flag storage issue: ' + err);
		}
	};

	// Checks for session storage flag set by embedded application or TC UI instance
	var monitorEmbeddedActivity = function() {
		if (isLogonComponentOrLocked()) return;

		try {
			// Use localStorage in favour of sessionStorage to monitor activity on popup windows in TC UI
			if ($window.localStorage.getItem('tc.embeddedActivity')) {
				// Once found, extend the lock timeout and remove the activity flag
				resetTimer();
				$window.localStorage.removeItem('tc.embeddedActivity');
			}
		} catch (err) {
			$log.log('Embedded flag storage issue: ' + err);
		}
	};

	// Start monitoring when navigating to an embedded/TC UI route
	var startMonitor = function(event, externalUrl) {
		if (activityMonitor !== null) return;
		// We may need to reinstate this to prevent monitoring in HS embedded instance...
		//if (GlobalService.logonData.isClinicalViewer) return;

		activityMonitor = $interval(monitorEmbeddedActivity, 3000);

		// Changing location should cancel the monitor
		// e.g. Navigating to another menu, manually locking the session, opening user details
		cancelMonitorUnbind = $rootScope.$on('$locationChangeStart', cancelMonitor); //eslint-disable-line

		// For externally embedded pages, allow communication via cross-domain postMessage calls
		if ((angular.isDefined(externalUrl)) && (externalUrl !== '')) {
			// URL() API would be preferred but not IE11 compatible..
			var pathArray = externalUrl.split('/');
			externalUrlOrigin = pathArray[0] + '//' + pathArray[2];
			$window.addEventListener('message', handleActivityMessage, false);
		}
	};

	// Cancel the monitor when navigating to a non-embedded/TC UI route
	var cancelMonitor = function() {
		if (activityMonitor === null) return;

		$interval.cancel(activityMonitor);
		activityMonitor = null;
		cancelMonitorUnbind();
		$window.removeEventListener('message', handleActivityMessage);
		if (activityMessageTimeout !== null) {
			$timeout.cancel(activityMessageTimeout);
			activityMessageTimeout = null;
		}
	};

	// Handles the messages posted by an externally embedded page
	// Allowing the external page to extend the inactivity timeout and optionally the CSP session
	var handleActivityMessage = function(event) {
		if (event.origin !== externalUrlOrigin) return;
		if (!angular.isObject(event.data)) return;

		// Only allow to extend every 1 second to avoid possibility of DOS attack
		if (activityMessageTimeout !== null) $timeout.cancel(activityMessageTimeout);
		activityMessageTimeout = $timeout(function() {
			var messageData = event.data.tc;
			if (angular.isDefined(messageData)) {
				if (messageData.activity === true) {
					if (messageData.extendSession === true) {
						SystemRouter.extendSession(); // SessionLockTimeoutInterceptor also calls resetTimer()
					} else {
						resetTimer();
					}
				}
			}
		}, 1000);
	};

	var setVisibilityChangeHandler = function() {
		if (angular.isUndefined($window.document.hidden)) return;
		$window.document.removeEventListener('visibilitychange', visibilityChangeHandler);
		$window.document.addEventListener('visibilitychange', visibilityChangeHandler, false);
	};

	var visibilityChangeHandler = function() {
		if (isLogonComponentOrLocked()) return;

		if (!$window.document.hidden) {
			// When returning to the browser tab, check if the timeout has expired.
			// For mobile devices that return from sleep mode (timers do not always function while device is asleep)
			if ((lockTimeoutTime > 0) && (Date.now() >= lockTimeoutTime)) {
				lockSession();
			}
		}
	};

	var isLogonComponentOrLocked = function() {
		return ((GlobalService.isSessionLocked)
				|| (['/Component/SSUserLogon','/DisabledSession'].indexOf($location.path()) !== -1));
	};

	var init = function init() {
		timeLockSession = GlobalService.logonData.timeLockSession;
		if (timeLockSession > 0) {
			$rootScope.$on('SessionLockTimeout:resetTimer', resetTimer); //eslint-disable-line
			$rootScope.$on('SessionLockTimeout:startMonitor', startMonitor); //eslint-disable-line
			// When displaying an embedded page, unlock may not trigger the http interceptor
			$rootScope.$on('Global:sessionUnlocked', resetTimer); //eslint-disable-line
			if (GlobalService.isTouchDevice()) {
				setVisibilityChangeHandler();
			}
			logoutOnLockSession = (GlobalService.configuration.misc.logoutOnLockSession === true);
		}
		$rootScope.$on('Global:userLogon', init); //eslint-disable-line
	};

	var SessionLockTimeout = {
		init: init
	};

	return SessionLockTimeout;
});

angular.module('tcApp')
.run(function(SessionLockTimeout) {
	SessionLockTimeout.init();
});

angular.module('tcApp')
.config(function($httpProvider) {
	// Intercept HTTP request and reset session timer
	var SessionLockTimeoutInterceptor = function SessionLockTimeoutInterceptor($rootScope) {
		return {
			'response': function(response) {
				$rootScope.$broadcast('SessionLockTimeout:resetTimer');
				return response;
			}

		};
	};

	$httpProvider.interceptors.push(SessionLockTimeoutInterceptor);

});

